import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

export const isDealRefreshDeferPending = (state: SalesCheckinRootState): boolean =>
    state.salesCheckin?.dealRefreshDefer?.pending ?? false;
